import { render, staticRenderFns } from "./results-panel.vue?vue&type=template&id=2e6a4568&scoped=true&"
import script from "./results-panel.vue?vue&type=script&lang=ts&"
export * from "./results-panel.vue?vue&type=script&lang=ts&"
import style0 from "./results-panel.vue?vue&type=style&index=0&id=2e6a4568&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6a4568",
  null
  
)

export default component.exports